<div class="d-flex gap-16 align-items-center w-100" *ngIf="user">
<!-- avatar -->
  <app-avatar-filler [user]="user" *ngIf="type == 'user'"></app-avatar-filler>

<!-- informations -->
  <div class="flex-grow-1">
    <h4 class="d-flex align-items-center justify-content-between font-trueno-bold">
    {{ user.name }}

      <!--   MENU GESTION USER   -->
      <div *ngIf="type == 'user'">
        <button class="btn border-0 h-fit-content w-fit-content" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu" >
<!--          <button mat-menu-item>-->
<!--            <span>Reset les informations</span>-->
<!--          </button>-->
          <button mat-menu-item>
            <span class="text-danger" *ngIf="currentUser.isGhost" (click)="deleteUser()">Supprimer l'utilisateur</span>
          </button>
        </mat-menu>
      </div>


      <!--   MENU GESTION PARTENAIRE   -->
      <div  *ngIf="type == 'partner'">
          <button class="btn border-0 h-fit-content w-fit-content" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
            <mat-icon>more_vert</mat-icon>
          </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="openModal(modal, 'fees')">
            <span>Modifier les frais du partenaire</span>
          </button>
          <button mat-menu-item (click)="openModal(modal, 'price')">
            <span>Modifier la surcharge du prix</span>
          </button>
          <button mat-menu-item (click)="refreshHousing()">
            <span>Rafraichir l'état des logements</span>
          </button>
          <button mat-menu-item (click)="openModal(modal, 'reset')">
            <span class="text-danger">Remettre toutes les valeurs par défaut</span>
          </button>
        </mat-menu>
      </div>


    </h4>




    <small class="lightGray2 d-block">#{{user.id}}</small>

    <div class="mt-2 font-14 d-flex align-items-center gap-8" *ngIf="user.email">
      <a class="mediumGray" href="mailto:{{user.email}}">{{ user.email }}</a>
      <mat-icon class="copy-icon font-10 pointer lightGray2 d-flex align-items-center justify-content-center" (click)="$event.stopPropagation()"
                [cdkCopyToClipboard]="user.email" ngbPopover="Copié !" placement="right" >filter_none</mat-icon>
    </div>
    <div class="mt-2 font-14" *ngIf="!user.email">
      email inconnu
    </div>

    <span class="mediumGray font-14">
      {{ user.phone && user.phone.trim().length > 0 ? user.phone : 'numéro inconnu' }}
      <mat-icon class="copy-icon font-10 pointer lightGray2 va-sub" (click)="$event.stopPropagation()"
                [cdkCopyToClipboard]="user.phone" ngbPopover="Copié !" placement="right" *ngIf="user.phone && user.phone.trim().length > 0 ">filter_none</mat-icon>
    </span>
  </div>
</div>



<ng-template #modal let-modal>
  <div class="modal-container py-3 px-3">
    <div class="d-flex">
      <h1 class="font-20 fw-bold" *ngIf="updateType != 'reset'">
        Modifier {{ updateType == 'fees' ? 'les frais du partenaire' : 'la surchage de prix' }}</h1>
      <h1 class="font-20 fw-bold" *ngIf="updateType == 'reset'">Êtes vous sûr.e ?</h1>
      <button type="button" class="btn border-0 m-0 ms-auto p-0" aria-label="Close" (click)="modal.dismiss()">
        <span class="material-icons-outlined text-black">close</span>
      </button>
    </div>

    <div class="mt-5" *ngIf="updateType != 'reset'">
       <span class="w-35">
         <!--     @TODO : mettre les datas    -->
         {{ updateType == 'fees' ? ('Anciens frais : ' + (user.fees ? user.fees : 0))  : (' Ancienne surchage : ' + (user[''] ? user[''] : 0)) }}
      </span>

      <div class="w-50 d-flex gap-8 text-nowrap align-items-center pe-2">
        {{ updateType == 'fees' ? 'Nouveaux frais :' : 'Nouvelle surchage :' }}
        <mat-form-field>
          <input matInput type="number" [(ngModel)]="updateForm">
        </mat-form-field>
      </div>
      <button class="w-100 btn mt-3 btn-lf-primary" (click)="updatePartner()">Modifier</button>
    </div>

<!--  @TODO : mettre ce qui est reset  -->
    <div class="mt-2" *ngIf="updateType == 'reset'">
      <p>Voulez-vous vraiment rétablir les valeurs par défauts pour {{user.name}} ? En faisant ça, vous allez:</p>
      <ul class="mt-2">
        <li>blabla</li>
        <li>blabla</li>
        <li>blabla</li>
      </ul>
      <button class="btn btn-danger mt-4 w-100" (click)="reset()">Rétablir les valeurs par défaut</button>
    </div>

  </div>
</ng-template>
